import React, { useEffect, useState } from "react";
import { TimeoutWarningModal } from "./timeoutWarningModel";
import { addEventListeners, removeEventListeners } from "./idleMonitor";
import { useNavigate } from "react-router-dom";
import { any } from "prop-types";
import { refreshToken, SignOutApi } from "../../utils/API";
import { constants } from "../../common/constants";
import { BroadcastChannel } from "broadcast-channel";

export const TimeoutLogic = () => {
  const navigate = useNavigate();
  const [isWarningModalOpen, setWarningModalOpen] = useState(false);
  const [resetTimer, setResetTimer] = useState<boolean>(false);
  const devTimeout: any = constants.DEV_TIMEOUT;
  const proTimeout: any = constants.ACTUAL_TIMEOUT;
  const logoutChannel = new BroadcastChannel("logout-channel");
  const timeOutset =
    process.env.REACT_APP_ENV === "SSSLOAN_DEV" ? devTimeout : proTimeout;
  useEffect(() => {
    var expiryToken: any = window.localStorage.getItem("expiryTimeInMs");

    const refreshToken: number = isNaN(parseInt(expiryToken))
      ? 0
      : parseInt(expiryToken);
    let expiryTimeDateTime = new Date(refreshToken);
    let currentDateTime = new Date();
    let currentDateTimeInMilliseconds = currentDateTime.getTime();
    let timerSeconds = refreshToken - currentDateTimeInMilliseconds;
    let timerleft = timerSeconds - 120000;
    if (refreshToken > currentDateTimeInMilliseconds) {
      const timers = setTimeout(() => {
        setWarningModalOpen(true);
      }, timerleft);
      return () => clearTimeout(timers);
    }
  }, [resetTimer]);

  logoutChannel.onmessage = (msg) => {
    let currentUser = window.sessionStorage.getItem("username");
    if (msg === "logout") {
      window.localStorage.clear();
      window.sessionStorage.clear();
      navigate("/signin");
    }
    else if (msg !== currentUser) {
      navigate("/signin");
    }
  };

  let tempSignOutObj: any = {
    refreshToken: any,
  };

  // Refresh Token Api call and session will refresh
  const continueSession = async () => {
    let refreshTokenApiRes: any = await refreshToken(tempSignOutObj);
    if (refreshTokenApiRes?.status === 200) {
      let refreshTokenApiData: any = await refreshTokenApiRes.json();
      window.localStorage.setItem(
        "refreshtoken",
        refreshTokenApiData.refreshToken
      );
      window.localStorage.setItem(
        "expiryTimeInMs",
        refreshTokenApiData.expiryTimeInMs
      );
      setTimeout(() => {
        setResetTimer(!resetTimer);
      }, 1000);
    } else if (refreshTokenApiRes.status === 401) {
      navigate("/signin");
    }
  };

  useEffect(() => {
    const idleTimeout = () =>
      setTimeout(() => {
        setWarningModalOpen(true);
      }, timeOutset);
    // Session Timeout modal pop up close session and log out force fully after 2 minutes
    const userAutoLogout = () =>
      setTimeout(async () => {
        logoutChannel.postMessage("logout");
        await SignOutApi();
        window.localStorage.clear();
        navigate("/signin");
      }, 120000);

    //Event Listener
    const listener = () => {
      if (!isWarningModalOpen) {
        clearTimeout(timeout);
        timeout = idleTimeout();
      }
    };

    // Initialization Event trigger
    let timeout = isWarningModalOpen ? userAutoLogout() : idleTimeout();
    addEventListeners(listener);

    // Session Cleanup
    return () => {
      removeEventListeners(listener);
      clearTimeout(timeout);
    };
  }, [isWarningModalOpen]);

  return (
    <div>
      {isWarningModalOpen && (
        <TimeoutWarningModal
          isOpen={isWarningModalOpen}
          onRequestClose={() => {
            setWarningModalOpen(false);
            continueSession();
          }}
        />
      )}
    </div>
  );
};
